export default __webpack_public_path__ + "static/media/IMG_0025.e44147a7.png";